import type { CrmPatientSummary } from "../types";

/**
 * Mescla `lastAppointmentAt` derivado do bundle FHIR nos resumos de paciente.
 * Não altera pacientes sem entrada no mapa (permanecem sem data).
 */
export function enrichPatientsWithLastAppointments(
  patients: CrmPatientSummary[],
  lastByPatientId: Map<string, string>,
): CrmPatientSummary[] {
  if (lastByPatientId.size === 0) return patients;

  return patients.map((p) => {
    const last = lastByPatientId.get(p.patientId);
    if (!last) return p;
    return { ...p, lastAppointmentAt: last };
  });
}
